


















import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {
  }
})

export default class CapacityModal extends Vue {
    @Prop() private errorTitle! : string;
    @Prop() private errorMessage! : string;

    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }
    private get userConfigBackgroundColor(){
        var style = {
            background: this.userConfigColor
        };
        return style;
    }
}
